module.exports = __webpack_public_path__ + "img/monthly-futures.a74df711.png";